import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";

const certs = [
  { name: "US FDA", desc: "21 CFR Part 210/211 alignment" },
  { name: "EU EMA", desc: "EudraLex Vol. 4 GMP practices" },
  { name: "WHO GMP", desc: "Prequalification-ready systems" },
  { name: "ICH Q7 / Q9 / Q10", desc: "Quality risk & lifecycle" },
  { name: "ISO 17025", desc: "Testing lab accreditation aligned" },
  { name: "MHRA / PIC/S", desc: "Inspection-ready documentation" },
];

export default function Certifications() {
  return (
    <section
      id="certifications"
      data-testid="certifications-section"
      className="bg-white py-24 lg:py-32 border-y border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="eyebrow mb-4">Standards We Work To</div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
              Aligned with the frameworks that matter.
            </h2>
          </div>
          <p className="lg:col-span-5 text-slate-600 leading-relaxed lg:text-right">
            We operate against globally recognised pharmaceutical quality frameworks and continuously update our
            protocols as guidance evolves.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {certs.map((c, i) => (
            <motion.div
              key={c.name}
              data-testid={`cert-${c.name.replace(/[^a-zA-Z0-9]/g, "-").toLowerCase()}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              className="p-6 border border-slate-200 hover:border-teal-500 hover:bg-teal-50/40 transition-all"
            >
              <BadgeCheck className="w-6 h-6 text-teal-700" strokeWidth={1.75} />
              <div className="mt-4 font-display text-sm font-semibold text-slate-900">{c.name}</div>
              <div className="mt-1 text-xs text-slate-500 leading-relaxed">{c.desc}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
